export default "__VITE_ASSET__B1_2NdLw__"